import {
  Button,
  IconButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Tooltip,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { MdDelete } from "react-icons/md";
import { UserModel } from "../../services";
import { useState } from "react";

export default function DeleteUserModal({ id, onDelete }) {
  const [loading, setLoading] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  const onSubmit = async () => {
    try {
      setLoading(true);
      let res = await UserModel.delete(id);
      if (res.status === 200) {
        toast({
          description: "User deleted successfully!",
          status: "success",
          isClosable: true,
        });
        onDelete(id);
        onClose();
      }
    } catch (error) {
      toast({
        description: "Something went wrong!",
        status: "error",
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Tooltip label="Delete User">
        <IconButton
          icon={<MdDelete />}
          bgColor="red.100"
          color="red.500"
          fontSize="xl"
          isRound
          onClick={onOpen}
        />
      </Tooltip>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="xl"
        scrollBehavior="inside"
        isCentered
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Delete User</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            Are you sure? Deleting the user account will delete all associated
            records.
          </ModalBody>
          <ModalFooter>
            <Button
              onClick={() => onClose()}
              bgColor="gray.200"
              color="black"
              borderRadius="lg"
              fontWeight="medium"
              py="6"
              px="7"
              me="2"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              onClick={onSubmit}
              isLoading={loading}
              loadingText="sending..."
              bgColor="black"
              borderRadius="lg"
              fontWeight="medium"
              py="6"
              px="7"
            >
              Confirm Delete
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
